import { type FC } from "react";
import TriggeredConfirmationModal from "../../triggeredConfirmationModal/TriggerableConfirmationModal";
import { Typography } from "../../common/Typography/Typography";
import type { IObservable } from "../../../interfaces";
import { NavLink } from "react-router";
import environmentConfig from "configuration/environmentConfig";

interface AddToBlackListProps {
  onTriggerModalObserver: IObservable<(onConfirm: () => void) => void>;
}

const helpCenterLink = environmentConfig.helpCenterUrl;
const helpCenterRelativeUrls = environmentConfig.helpCenterRelativeUrls;
const supportLink = `${helpCenterLink}/${helpCenterRelativeUrls.noContactUrl}`;

const AddToBlackList: FC<AddToBlackListProps> = ({ onTriggerModalObserver }) => {
  return (
    <TriggeredConfirmationModal
      title="Add to No Contact List"
      content={
        <div>
          <Typography variant="title1">
            The selected user(s) will be added to the email and messages no contact list and will no longer receive
            non-critical communications from the platform. This includes updates such as content prioritization, group
            additions, and daily or weekly digests. You can remove them from the no contact list at any time.
          </Typography>
          <br />
          <NavLink target="_blank" style={{ textDecoration: "underline" }} to={supportLink}>
            Learn more in our Help Center
          </NavLink>
        </div>
      }
      confirmButtonLabel="Add to List"
      onTriggerModalObserver={onTriggerModalObserver}
    />
  );
};

export default AddToBlackList;
